import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import React from 'react'

const LearningContinuaSkeleton = ({ length = 10 }) => {
  return (
    <Box className='py-1 flex flex-col gap-2'>
      {Array.from({ length }).map((_, index) => (
        <div className="flex w-full gap-2" key={`learning-continua-skelenton-${index}`}>
          <Skeleton variant="rectangular" width={120} height={30} className='rounded' />
          <Skeleton variant="rectangular" width='100%' height={30} className='rounded' />
        </div>
      ))}
    </Box>
  );
}

export default LearningContinuaSkeleton